import { QuizAttachmentType, QuizForm, QuizFormUpdate, QuizPattern, QuizState } from "@/interfaces/sdk-quiz";
import { removeSelectedQuiz, setQuizAttachmentTypes, setQuizPatterns, setQuizzes } from "./types";

export default {
  [setQuizzes](state: QuizState, data: QuizForm[]) {
    state.quizzes = data;
  },
  [setQuizPatterns](state: QuizState, data: QuizPattern[]) {
    state.patterns = data;
  },
  [removeSelectedQuiz](state: QuizState, id: number) {
    const targetIndex = (state.quizzes as QuizFormUpdate[]).findIndex((quiz) => quiz.id === id);
    state.quizzes.splice(targetIndex, 1);
  },
  [setQuizAttachmentTypes](state: QuizState, data: QuizAttachmentType[]) {
    state.attachmentTypes = data;
  },
};
